import { render, staticRenderFns } from "./baseBtraMto.vue?vue&type=template&id=fdafd8d8"
import script from "./baseBtraMto.vue?vue&type=script&lang=js"
export * from "./baseBtraMto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports